export default __webpack_public_path__ + "adb49cb0512a6f006b6dc63b0d15d7ba.svg";